import { useState } from "react";
import {  Link } from "react-router-dom";

// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

// var ps;

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {useDispatch} from 'react-redux'
import {logout} from 'actions/userActions'
import { useSelector } from 'react-redux'; 

import UserIcon from '../../assets/img/Sample_User_Icon.png'
import Logo from '../../assets/img/Logo_APP.png'

import LanguageSelector from '../LanguageSelector'

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
 
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };

  const { logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  /////////////

  const { t } = useTranslation();

  const navigate = useNavigate()  

  const dispatch = useDispatch()

  const logoutHandler = () => {
    dispatch(logout())
    navigate("/")
  }

  const is_developer = useSelector((state) => state.userLogin.userInfo.is_developer);

  const is_insurance_profile = useSelector((state) => state.userLogin.userInfo.is_insurance_profile);
  
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const handlemodal = () => {
      setIsUpgradeModalOpen(true);
  };

  /////////////

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              src={Logo}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <LanguageSelector/>
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    src={UserIcon}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">{t('Welcome!')}</h6>
              </DropdownItem>
              <DropdownItem to="/profile/" tag={Link}>
                <i className="ni ni-single-02" />
                <span>{t('My profile')}</span>
              </DropdownItem>
              <DropdownItem to="/support/" tag={Link}>
                <i className="ni ni-support-16" />
                <span>{t('Support')}</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={logoutHandler}>
                <i class="fa-solid fa-right-from-bracket"></i>
                <span>{t('Logout')}</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                          <img alt={logo.imgAlt} src={Logo} />
                      </div>
                    </>
                    // <Link to={logo.innerLink}>
                    //   <img alt={logo.imgAlt} src={"https://i.ibb.co/NZ8qZsk/111111.png"} /> {" "} AIBIOSAT
                    // </Link>
                  ) : (
                    //<a href={logo.outterLink}>
                    <>
                      <img alt={logo.imgAlt} src={Logo} />
                    </>
                    //</Col></a>                    
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <h6 className="navbar-heading text-muted">Home</h6>
          <Nav className="mb-md-3" navbar>
            <NavItem>
              <NavLink href="/">
                <i className="fa fa-home" />
                  Dashboard
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/data/">
                <i class="fa-solid fa-table-list"></i>
                {t('Table')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/photo/">
                <i class="fa-regular fa-images"></i>
                {t('Photo')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/map/">
                <i class="fa-solid fa-map"></i>
                  {t('Map')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/prescription-map/">
                <i class="fa-solid fa-map-location-dot"></i>
                {t('Prescription Map')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/data-management/">
                <i class="fa-solid fa-database"></i>
                {t('Data Management')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/connect-insurance-service/">
                <i class="fa-solid fa-user-shield"></i>
                  {t('Agricultural Insurance Connect')}
              </NavLink>
            </NavItem>
          </Nav>

          <hr className="my-3" />

          <h6 className="navbar-heading text-muted">{t('Developer')}</h6>

          {is_developer ? (
            <>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink href="/api/">
                    <i class="fa-solid fa-terminal"></i>
                    {t('API')}
                  </NavLink>
                </NavItem>
              </Nav>
            </>
          ):(
            <>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-terminal"></i>
                    {t('API')}
                    <span className="badge badge-danger ml-2">{t('Developer')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </>
          )}

          

          <hr className="my-3" />

          <h6 className="navbar-heading text-muted">{t('Agricultural Insurance')}</h6>
          
          {is_insurance_profile ? (
            <>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink href="/insurance-profile/">
                    <i class="fa-solid fa-user-tie"></i>
                    {t('Insurance Account')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/list-request/">
                    <i class="fa-solid fa-list-check"></i>
                    {t('List of request')}
                  </NavLink>
                </NavItem>                
                <NavItem>
                  <NavLink href="/list-devices/">
                    <i class="fa-solid fa-tower-broadcast"></i>
                    {t('Devices')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/damage-list-insurance/">
                    <i class="fa-solid fa-land-mine-on"></i>
                    {t('Damage Report')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/map-insurance/">
                    <i class="fa-solid fa-layer-group"></i>
                    {t('Map')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/insurance-table/">
                    <i class="fa-solid fa-table-list"></i>
                    {t('Table')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/insurance-comparation/">
                    <i class="fa-solid fa-code-compare"></i>
                    {t('Comparation')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/insurance-photo/">
                    <i class="fa-regular fa-images"></i>
                    {t('Photo')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/insurance-mobile-data/">
                    <i class="fa-solid fa-mobile"></i>
                    {t('Manual acquisition - Phone data')}
                  </NavLink>
                </NavItem>
              </Nav>
            </>
          ):(
            <>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-user-tie"></i>
                    {t('Insurance Account')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem onClick={handlemodal}>
                  <NavLink href="#">
                    <i class="fa-solid fa-list-check"></i>
                    {t('List of request')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-tower-broadcast"></i>
                    {t('Devices')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-land-mine-on"></i>
                    {t('Damage Report')}
                     <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-layer-group"></i>
                    {t('Map')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-table-list"></i>
                    {t('Table')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={handlemodal}>
                    <i class="fa-solid fa-code-compare"></i>
                    {t('Comparation')}
                    <span className="badge badge-danger ml-2">{t('Insurance')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </>
          )}
          
          <hr className="my-3" />

          <h6 className="navbar-heading text-muted">{t('Profile')}</h6>
          <Nav className="mb-md-3" navbar>
            <NavItem>
              <NavLink href="/profile/">
                <i class="fa-solid fa-user-gear"></i>
                {t('Profile')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/add-new-models/">
                <i class="fa-solid fa-arrow-up-right-dots"></i>
                {t('Add New Crop Model')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/add-new-device/">
                <i class="fa-solid fa-user-plus"></i>
                {t('Add new device')}
              </NavLink>
            </NavItem>
          </Nav>

        </Collapse>    

        <Modal isOpen={isUpgradeModalOpen} toggle={() => setIsUpgradeModalOpen(false)}>
          <ModalHeader toggle={() => setIsUpgradeModalOpen(false)}>
            {t('Upgrade your account')}
          </ModalHeader>
          <ModalBody>
            <p>{t('If you want to access to this module, you must change your account settings')}</p>
            <Link to="/profile/">
              <Button color="success" onClick={() => setIsUpgradeModalOpen(false)}>
                {t('Change account settings')}
              </Button>
            </Link>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => setIsUpgradeModalOpen(false)}>
              {t('Not Now')}
            </Button>
          </ModalFooter>
        </Modal>   
        
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
